import { gql } from 'graphql.macro';
import { webhookSubscriptionFieldsFragment } from './query.graphql';

export const createWebhookSubscriptionTemplate = gql`
    mutation createWebhookSubscription($input: CreateWebhookSubscriptionInput!) {
        createWebhookSubscription(input: $input) {
            subscription {
                ...webhookSubscriptionFields
            }
            secret
        }
    }
    ${webhookSubscriptionFieldsFragment}
`;

export const rotateWebhookSubscriptionSecretTemplate = gql`
    mutation rotateWebhookSubscriptionSecret($id: MongoDbObjectId!) {
        rotateWebhookSubscriptionSecret(id: $id) {
            subscription {
                ...webhookSubscriptionFields
            }
            secret
        }
    }
    ${webhookSubscriptionFieldsFragment}
`;

export const setWebhookSubscriptionActiveTemplate = gql`
    mutation setWebhookSubscriptionActive($id: MongoDbObjectId!, $active: Boolean!) {
        setWebhookSubscriptionActive(id: $id, active: $active) {
            ...webhookSubscriptionFields
        }
    }
    ${webhookSubscriptionFieldsFragment}
`;

export const updateWebhookSubscriptionTemplate = gql`
    mutation updateWebhookSubscription($id: MongoDbObjectId!, $input: UpdateWebhookSubscriptionInput!) {
        updateWebhookSubscription(id: $id, input: $input) {
            ...webhookSubscriptionFields
        }
    }
    ${webhookSubscriptionFieldsFragment}
`;

export const deleteWebhookSubscriptionTemplate = gql`
    mutation deleteWebhookSubscription($id: MongoDbObjectId!) {
        deleteWebhookSubscription(id: $id)
    }
`;

export const triggerWebhookSubscriptionTestTemplate = gql`
    mutation triggerWebhookSubscriptionTest($id: MongoDbObjectId!) {
        triggerWebhookSubscriptionTest(id: $id)
    }
`;
